export default __webpack_public_path__ + "static/media/express.493a0dd0.svg";